import { extractAirportName } from "../../utils/functions";

export const getAirportRoutes = (id: any, airports: any, routes: any) => {
  const airport = airports.filter((airport: any) => airport.id === id)[0];
  const airportRoutes = routes
    .filter(
      (route: any) =>
        route.pastFlights > 0 &&
        (route.dep === airport.id || route.arr === airport.id)
    )
    .map((route: any) => {
      return {
        ...route,
        depName: extractAirportName(airports, route.dep),
        arrName: extractAirportName(airports, route.arr)
      };
    })
    // .sort((a: any, b: any) => (a.dep !== id && b.dep === id ? -1 : 1))
    .sort(
      (a: any, b: any) =>
        a.pastFlights === b.pastFlights
          ? a.dep !== id && b.dep === id
            ? 1
            : a.dep === b.dep
              ? a.arrName < b.arrName
                ? -1
                : 1
              : a.depName < b.depName || a.dep === id
                ? -1
                : 1
          : a.pastFlights < b.pastFlights
            ? 1
            : -1
    );

  return airportRoutes;
};

export const getRouteIcon = (id: any, route: any) => {
  return id === route.dep ? "flight_takeoff" : "flight_landing";
};
